var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-center text-center"},[_c('SkeletonList'),_c('q-btn',{staticStyle:{"width":"200px"},attrs:{"color":"secondary"},on:{"click":function($event){return _vm.$router.push('/dashboard')}}},[_vm._v("Go back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }